import React from 'react'

function Sekond() {
    return (
<section className="about" id="about">
    <div className="about-inner">
      <h1>НАША КОМАНДА СПЕЦИАЛИЗИРУЕТСЯ <br />НА РАБОТЕ С HTML НА ПРОФЕССИОНАЛЬНОМ УРОВНЕ</h1>
      <h2>ПОЧЕМУ НАС ВЫБИРАЮТ?</h2>
      <div className="about-list">
        <div className="about-item">
          <span className="about-text">
            <h2>Качественно</h2>
          </span>
        </div>
        <div className="about-item">
          <span className="about-text">
            <h2>Профессиональная работа</h2>
          </span>
        </div>
        <div className="about-item">
          <span className="about-text">
            <h2>Номер 1 во всей стране</h2>
          </span>
        </div>
      </div>
      <div className="about-item">
        <img src="https://cdn.discordapp.com/attachments/838171687022362677/842118186853203989/Untitled283_20210513011646.png" alt />
        <h5>Вы спросите почему именно Ель<br />Мы вам ответим мы называемся Елью потому что<br />Мы корни молодой ели. За этот короткий промежуток времени, мы создали свою компанию, и ель стала расти. Все время она будет расти, а мы развиваться</h5>
      </div>
    </div>
</section>

    )
}

export default Sekond
